import { AsYouType } from 'libphonenumber-js';

const isPhoneValid = (phone: string) => {
  const phoneRegex = new RegExp('^[2-9]{1}[0-9]{2}[0-9]{3}[0-9]{4}$');
  if (!phone || phone.length !== 10 || !phoneRegex.test(phone)) {
    return false;
  }
  return true;
};

const usPhone = new AsYouType('US');

export function formatPhone(phone: string) {
  const clean = phone
    .replace(/^1/, '')
    .replace(/[^\d]+/gi, '')
    .substr(0, 10);
  const r = usPhone.input(clean);
  usPhone.reset();
  return r;
}

export default {
  accept: /\d+/g,
  // do not jump after ) until see number before
  mask: (value: string) => {
    return value.length < 6 && /[^\d]+/.test(value[3]) ? undefined : value.length >= 14;
  },
  // format: formatPhone
  format: formatPhone,
  isPhoneValid,
};
